<app-card>
  <ng-container cardBody>
    <div class="d-flex w-100 align-items-center justify-content-center flex-column scanner-components">
      <app-scanner-ui-input
        (afterFinishScan)="updateScanner($event)"
        [productId]="productId"
        [soId]="soId"></app-scanner-ui-input>
      <h1 class="mt-10">Silahkan scan QR yang terdapat di box produk.</h1>
    </div>
  </ng-container>
</app-card>
<div class="mt-10">
  <app-card>
    <ng-container cardBody>
      <div class="d-flex align-items-center justify-content-between w-100">
        <h1>List Produk</h1>
        <button (click)="onOpenModal()" class="btn btn-outline text-primary">Input Kode Manual</button>
      </div>
    </ng-container>
  </app-card>
</div>
<app-modal #modalInputManual [modalConfig]="modalInputManualConfig">
  <div class="fs-7 mb-4">Silahkan masukkan kode yang tertera pada QR dengan benar.</div>
  <app-scanner-ui-input
    (afterFinishScan)="updateScanner($event)"
    [isManualInput]="true"
    [productId]="productId"
    [soId]="soId"></app-scanner-ui-input>
</app-modal>
